import type { Store } from 'redux';
import type { Epic } from 'redux-observable';
import initiateStore from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import type { Action } from './actions/index.tsx';
import rootReducer from './reducer/index.tsx';
import type { State } from './types.tsx';

const createStore = (rootEpic?: Epic<Action, State>, initialState?: State): Store<State> =>
	initiateStore<State, Action, undefined>({
		initialState,
		appName: 'directories/filters',
		rootReducer,
		rootEpic,
	});

export default createStore;
